import { Table, TableProps, Tag, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { Link, createSearchParams } from 'react-router-dom';

import { SerialID, UUID } from '../types';

interface EmailTemplateType {
  value: string;
  label: string;
}

interface EmailTemplateFormat {
  id: SerialID | UUID;
  name: string;
  type: string;
}

interface EmailTemplateTableProps extends TableProps<EmailTemplateFormat> {
  templateTypes: EmailTemplateType[];
  activeWelcomeTemplate?: SerialID;
  searchParams?: URLSearchParams;
}

const EmailTemplateTable = ({
  templateTypes,
  activeWelcomeTemplate,
  pagination,
  searchParams,
  ...props
}: EmailTemplateTableProps) => {
  const { t } = useTranslation();

  return (
    <Table<EmailTemplateFormat>
      rowKey="id"
      pagination={{
        showTotal: (total) => {
          return `Total: ${total} modelos`;
        },
        ...pagination,
      }}
      {...props}
    >
      <Table.Column
        key="name"
        title={t('Nome do modelo')}
        dataIndex="name"
        render={(_, record: EmailTemplateFormat) => (
          <>
            <Link
              className="ant-typography-link"
              to={{
                pathname: `${record.id}/change`,
                search: createSearchParams(searchParams).toString(),
              }}
            >
              {record.name}
            </Link>{' '}
            {record.id === activeWelcomeTemplate && (
              <Tag>
                <Trans>Modelo padrão de boas-vindas</Trans>
              </Tag>
            )}
          </>
        )}
      />
      <Table.Column
        key="type"
        title={t('Tipo')}
        render={(_, record: EmailTemplateFormat) => (
          <Typography.Text>
            {templateTypes.find(({ value }) => value === record.type)?.label || ''}
          </Typography.Text>
        )}
      />
    </Table>
  );
};

export default EmailTemplateTable;
